import { FactSliderModalController } from './slider/facts-slider-modal.component';
import { getTableViewByType } from './table-view';
import { WSPLITTER } from '../common/config';

require('./facts.component.scss');

/* global gettext */

class FactsController {
  constructor(
    $scope,
    $timeout,
    $element,
    AudioService,
    $modal,
    RouterService,
  ) {
    this.$scope = $scope;
    $scope.generateReport = RouterService.generateReport.bind(RouterService);
    $scope.isCollapsed = true;

    $scope.selectedFact = $scope.filterData.filterData &&
    $scope.filterData.filterData.length ? $scope.filterData.filterData[0] : null;
    if ($scope.selectedFact) {
      $scope.selectedFact.selected = true;
    }

    $scope.getNextAudio = ({select}) => {
      let eventIndex = $scope.getEventIndex();
      while (eventIndex < $scope.filterData.filterData.length && eventIndex >= 0) {
        eventIndex = eventIndex + 1;
        if (eventIndex + 1 >= $scope.filterData.filterData.length) {
          $scope.more();
        }
        if (eventIndex >= 0) {
          let fact = $scope.filterData.filterData[eventIndex];
          if (fact && fact['agent_eventtype.id'] === 21) {
            if (select) {
              $scope.select(fact);
              $scope.$apply();
            }
            return fact;
          }
        }
      }
    };
    AudioService.loadNextAudio = () => {
      let nextFact = $scope.getNextAudio({select: false});
      if (nextFact && nextFact.audio && !nextFact.audioLoad) {
        // console.log('load audio', nextFact.audio.src);
        nextFact.audio.load();
        nextFact.audioLoad = true;
      }
    };
    AudioService.playNextAudio = () => {
      let nextFact = $scope.getNextAudio({select: true});
      if (nextFact && nextFact.audio) {
        AudioService.play(nextFact.audio);
        nextFact.audioLoad = true;
      }
    };

    $scope.select = function (fact) {
      if (fact === $scope.selectedFact) {
        return;
      }

      if ($scope.selectedFact) {
        $scope.selectedFact.selected = false;
      }
      $scope.selectedFact = fact;
      fact.selected = true;
      let position1 = $element.find('#tr' + fact.id).position() || 0;
      let eventTable = $element.find('.fact-table-tbody');
      let current = eventTable.scrollTop();
      let tbody_height = eventTable.height();
      eventTable.animate({
        scrollTop: current + position1.top -
        tbody_height / 3,
      }, 100);
      $scope.$broadcast('showPane2');
    };
    $scope.deselect = () => {
      if ($scope.selectedFact) {
        $scope.selectedFact.selected = false;
        $scope.selectedFact = null;
        $scope.$broadcast('hidePane2');
        $scope.$apply();
      }
    };

    $scope.leaf = step => {
      let eventIndex = $scope.getEventIndex();
      if (eventIndex + step >= $scope.filterData.filterData.length) {
        $scope.more();
      } else {
        eventIndex = eventIndex + step;
        if (eventIndex < 0) eventIndex = 0;
        //                 console.log('eventIndex: ' + eventIndex);
        let fact = $scope.filterData.filterData[eventIndex];
        $scope.select(fact);
        $scope.$apply();
      }
    };
    $scope.getEventIndex = () => $scope.selectedFact ?
      $scope.filterData.filterData.indexOf($scope.selectedFact) : 0;
    $scope.leafToLast = () => {
      let moveTo = $scope.filterData.filterData && $scope.filterData.filterData.length ?
        $scope.filterData.filterData[$scope.filterData.filterData.length - 1] : null;
      if (moveTo) {
        $scope.select(moveTo);
        $scope.$apply();
      }
    };
    $scope.leafToFirst = () => {
      let moveTo = $scope.filterData.filterData &&
      $scope.filterData.filterData.length ?
        $scope.filterData.filterData[0] : null;
      if (moveTo) {
        $scope.select(moveTo);
        $scope.$apply();
      }
    };

    $scope.showImage = fact => {
      $scope.select(fact);
      if ($scope.imageDialog) {
        $scope.imageDialog.close();
      }
      $scope.imageDialog = $modal.open({
        scope      : $scope,
        template   : require('./slider/facts-slider-modal.component.html'),
        controller : FactSliderModalController,
        windowClass: 'showImageModal',
      });
    };
    $scope.closeDialog = () => {
      if ($scope.imageDialog) {
        $scope.imageDialog.close();
      }
    };

    $scope.$watch('viewMode', newVal => {
      $scope.$broadcast('viewModeChanged', newVal);
    });
    $scope.$watch('filterData.filterData', (newVal, oldVal) => {
      let filter = $scope.filter;
      if (filter) {
        $scope.viewMode = getTableViewByType(
          filter.viewModeType(),
          filter.filters,
        );
      }
      //$element.find('.fact-table-tbody').focus();
      if (!$scope.filterData.filterData ||
        !~$scope.filterData.filterData.indexOf($scope.selectedFact)) {
        $scope.selectedFact = null;
      }
      if (!$scope.selectedFact) {
        $scope.$broadcast('hidePane2');
      }
    }, false);

    let keyboardEvents = {
      13: function () {
        $scope.showImage($scope.selectedFact);
      }, // Enter
      27: function () {
      }, // Esc
      32: function () {
        $scope.leaf(1);
      }, // Space
      33: function () {
        $scope.leaf(-5);
      }, // PgUp
      34: function () {
        $scope.leaf(5);
      }, // PgDown
      35: function () {
        $scope.leafToLast();
      }, // End
      36: function () {
        $scope.leafToFirst();
      }, // Home
      37: function () {
        $scope.leaf(-1, true);
      }, // Left
      38: function () {
        $scope.leaf(-1);
      }, // Up
      39: function () {
        $scope.leaf(1, true);
      }, // Right
      40: function () {
        $scope.leaf(1);
      } // Down
    };
    $scope.bindEvents = function () {
      $element.on('keydown', e => {
        let code = e.which;
        //                 console.log(code);
        if (code in keyboardEvents) {
          keyboardEvents[code]();
          e.preventDefault();
        }
      });
    };

    $scope.splitter = {pos: WSPLITTER};
    Object.defineProperty($scope, 'listType', {
      get: () => {
        return $scope.filter.listType;
      },
    });
    $scope.more = () => $scope.loadMore && $scope.filterData.moreFacts();

    let subscriptions = [$scope.filterData.filterData$.subscribe(() => {
      $scope.$root.$broadcast('factsLoaded');
    })];
    $scope.$on('$destroy', () => subscriptions.forEach((subscription) =>
      subscription.dispose()));
  }

  toggleSortOrder() {
    const filter = this.$scope.filter;
    filter.orderDir = filter.orderDir === 'desc' ? 'asc' : 'desc';
    this.$scope.filterData.update(filter);
  }
}

export function FactsComponent(
  $compile,
  $timeout,
  RouterService,
) {
  return {
    restrict: 'E',
    scope   : {
      model     : '<',
      filter    : '<',
      filterData: '<',
      showFactsInfo: '<',
      loadMore: '<',
    },
    template: require('./facts.component.html'),
    controller: FactsController,
    controllerAs: '$ctrl',
    link      : function (scope, element, attrs) {
      scope.$watch('filter.listType', (newVal, oldVal) => {
        scope.bindEvents();

        // Send event to update table columns
        if (newVal === 'table') {
          $timeout(() => {
            scope.$broadcast('viewModeChanged', scope.viewMode);
          });
        }

        if (newVal === 'table') {
          element.find('.fact-table-tbody').focus();
        } else if (newVal === 'thumblist') {
          element.find('.fact-thumbnail-list').focus();
        }

        element.click('.widget-value', event => {
          let el = angular.element(event.target);
          if (el.attr('data-key')) {
            scope.$apply(() => {
              let key = el.attr('data-key');
              if (key === 'agent_web@url:url') {
                return window.open(el.attr('data-value'));
              }
              if (key === 'id@default:id') {
                RouterService.setFilter(key,
                  el.attr('data-value'), el.attr('data-label')
                );
                return;
              }
              // todo when $compileProvider.debugInfoEnabled is set to false,
              // calling .scope() on a DOM node will return undefined
              const fact = el.scope().fact;
              let filter = scope.model.getCellFilter(key, fact);
              RouterService.drilldownFilter(filter);
            });
          }
        });
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/facts.component.js